import { SitecoreForm } from '@sitecore-jss/sitecore-jss-forms';
import { FormProps } from '@sitecore-jss/sitecore-jss-react-forms/types/components/form';
import classNames from 'classnames';
import Script from 'next/script';

import { useFormController } from '../../hooks/useFormController';
import { useFormScript } from '../../utilities/useFormScript';
import FieldValidationError from '../Shared/FieldValidationError';
import FormValidationError from '../Shared/FormValidationError';
import JabraLabel from '../Shared/JabraLabel';
import { FormComponent } from './FormComponent';

interface FormBodyProps {
  form: SitecoreForm;
  controller: ReturnType<typeof useFormController>;
  fieldFactory: FormProps['fieldFactory'];
  fieldWrapperComponent: FormProps['fieldWrapperComponent'];
  labelComponent?: FormProps['labelComponent'];
}

const FormBody = ({
  form,
  controller,
  fieldFactory,
  fieldWrapperComponent,
  labelComponent = JabraLabel,
}: FormBodyProps) => {
  const formScript = useFormScript();
  const {
    cssClass,
    actionAttributes,
    scripts,
    sharedFormProps,
    onRedirect,
    customFormFetcher,
    handleFieldChange,
  } = controller;

  return (
    <>
      {scripts.localScriptTop && (
        <div dangerouslySetInnerHTML={{ __html: scripts.localScriptTop }} />
      )}
      {scripts.globalScriptTop && (
        <div dangerouslySetInnerHTML={{ __html: scripts.globalScriptTop }} />
      )}

      {Object.entries(actionAttributes).map(([key, value]: [string, string], index) => {
        const gtmAttribute = {
          [key]: value,
        };

        return <input key={`action-${index}`} type="hidden" {...gtmAttribute} />;
      })}
      <FormComponent
        form={form}
        fieldFactory={fieldFactory}
        language={sharedFormProps.language}
        sitecoreApiHost={sharedFormProps.sitecoreApiHost}
        sitecoreApiKey={sharedFormProps.sitecoreApiKey}
        trackerFetcher={() => {}}
        className={classNames('flex flex-wrap', cssClass)}
        errorComponent={FormValidationError}
        fieldValidationErrorsComponent={FieldValidationError}
        fieldWrapperComponent={fieldWrapperComponent}
        labelComponent={labelComponent}
        onRedirect={onRedirect}
        formFetcher={customFormFetcher}
        onFieldChangeCallback={handleFieldChange}
      />
      {scripts.localScriptBottom && (
        <div dangerouslySetInnerHTML={{ __html: scripts.localScriptBottom }} />
      )}
      {scripts.globalScriptBottom && (
        <div dangerouslySetInnerHTML={{ __html: scripts.globalScriptBottom }} />
      )}
      {formScript && <Script id="form-script" dangerouslySetInnerHTML={{ __html: formScript }} />}
      {scripts.globalCss && <div dangerouslySetInnerHTML={{ __html: scripts.globalCss }} />}
      {scripts.localCss && <div dangerouslySetInnerHTML={{ __html: scripts.localCss }} />}
    </>
  );
};

export default FormBody;
